import { GLOBAL_FETCH_SIGNAL, fetchUrl } from './settings';

import { ActionType } from '../action-types';
import { getVisibleAccounts } from './actions';
import fetch from "fetch-retry";

export const checkIfEmailAlreadyExists = (value) => (dispatch, getState) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/check-email`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({
			email: value,
		}),
	})
		.then((resp) => {
			if (!resp.ok) {
				throw Error(resp.statusText);
			}
			return resp.json();
		})
		.then((data) => {
			if (data.AccountExistsWithEmail) {
				return dispatch({
					type: ActionType.EMAIL_EXISTS,
					emailExists: data.AccountExistsWithEmail,
				});
			}
		})
		.catch((error) => {
			return dispatch({
				type: ActionType.FETCH_ERROR,
			});
		});
};

export const validateEmail = (email) => (dispatch) => {
	const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	if (emailRegex.test(email)) {
		return dispatch({
			type: ActionType.VALIDATION_SUCCESS,
			field: 'email',
			value: email,
		});
	} else {
		return dispatch({
			type: ActionType.VALIDATION_FAILURE,
			field: 'email',
		});
	}
};

export const forgotPassword = (email: string) => (dispatch) => {
	fetch(`${fetchUrl}/remind-password`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({
			email: email,
		}),
	}).then((resp) => {
		if (resp.status === 400) {
			return dispatch({
				type: ActionType.RESET_PASSWORD_TIMEOUT_FAILED,
			});
		}
		if (resp.ok) {
			return dispatch({
				type: ActionType.RESETTING_PASSWORD_SUCCEED,
			});
		}
		return dispatch({
			type: ActionType.RESETTING_PASSWORD_FAILED,
		});
	});
};

export const closeEmailNotification = () => (dispatch) => {
	dispatch({
		type: ActionType.CLOSE_EMAIL_NOTIFICATION,
	});
};

// Database
export const saveAccountEdition = (account) => (dispatch, getState) => {
	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/account`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(account),
	})
		.then((resp) => {
			if (!resp.ok) {
				throw Error(resp.statusText);
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({
				type: ActionType.VALIDATION_SUCCESS,
				updated: 'Succeeded',
				account: account,
			});
			return true;
		})
		.catch((error) => {
			dispatch({ type: ActionType.VALIDATION_FAILURE, updated: 'Fail' });
		});
};

export const editAccount = (account, loggedUserId) => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_EDIT_ACCOUNT_NOTIFICATION });
	dispatch({ type: ActionType.DISABLE_EDIT_ACCOUNT_BUTTON });

	let token = localStorage.getItem('w4-token');
	fetch(`${fetchUrl}/account`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify(account),
	})
		.then((resp) => {
			if (resp.status !== 200 && resp.status !== 201 && resp.status !== 409) {
				dispatch({ type: ActionType.EDIT_ACCOUNT_FAIL });
			} else if (resp.status === 409) {
				dispatch({ type: ActionType.EMAIL_OR_PHONE_ALREADY_TAKEN });
			}
			return resp.json();
		})
		.then((data) => {
			if (data.succeeded) {
				dispatch({
					type: ActionType.EDIT_ACCOUNT_SUCCESS,
					account: account,
				});
			}
		})
		.then(() => {
			dispatch(getVisibleAccounts());
		})
		.then(() => {
			if (loggedUserId === account.accountID) {
				dispatch({
					type: ActionType.REFRESH_USER_NAME,
					account: account,
				});
			}
		})
		.catch((error) => {
			dispatch({ type: ActionType.EDIT_ACCOUNT_FAIL });
			console.error(error);
		});
};

export const changePassword = (value) => (dispatch) => {
	fetch(`${fetchUrl}/change-password`, {
		body: JSON.stringify(value),
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
		},
		method: 'POST',
	})
		.then((resp) => {
			if (!resp.ok) {
				dispatch({ type: ActionType.RESETTING_PASSWORD_FAILED });
				throw Error(resp.statusText);
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.RESETTING_PASSWORD_SUCCEED });
			return true;
		})
		.catch((error) => {
			dispatch({ type: ActionType.RESETTING_PASSWORD_FAILED });
		});
};

export const getResetPasswordEmail = (token, email) => (dispatch) => {
	fetch(`${fetchUrl}/change-password/${token}`, {
		method: 'GET',
	})
		.then((resp) => {
			if (!resp.ok) {
				throw Error(resp.statusText);
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({
				type: ActionType.GET_CENSORED_MAIL,
				changedPasswordEmail: data.email,
			});
		})
		.catch((error) => {
			dispatch({ type: ActionType.GET_CENSORED_MAIL_FAIL });
		});
};

export const closeSavePasswordNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_SAVE_PASSWORD_NOTIFICATION });
};

export const closeEditAccountNotification = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_EDIT_ACCOUNT_NOTIFICATION });
};

export const detachAccountFromSystemByID = (accountID, systemID) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/detach-account`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({ accountID, systemID }),
	})
		.then((resp) => {
			if (!resp.ok) {
				throw Error(resp.statusText);
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.DETACH_ACCOUNT_FROM_SYSTEM, detachConfirmed: true, accountID: accountID, systemID: systemID });
		})
		.then(() => {
			dispatch(getVisibleAccounts());
		})
		.catch((error) => {
			alert('Detach failed');
			dispatch({ type: ActionType.FETCH_ERROR });
		});
};

export const closeDetachAccountNotification = () => (dispatch) => {
	dispatch({ type: ActionType.DETACH_ACCOUNT_FROM_SYSTEM, detachConfirmed: false });
};

export const getVisibleSystemsForAccountShort = (accountID) => (dispatch) => {
	dispatch({ type: ActionType.WAS_FETCHED_VISIBLE_SYSTEMS_FOR_ACCOUNT, wasFetchedVisibleSystems: false });
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/account-systems-relation/${accountID}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
	})
		.then((resp) => {
			if (!resp.ok) {
				throw Error(resp.statusText);
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.GET_VISIBLE_SYSTEMS_FOR_ACCOUNT, systemsDetails: data, accountID: accountID });
			dispatch({ type: ActionType.WAS_FETCHED_VISIBLE_SYSTEMS_FOR_ACCOUNT, wasFetchedVisibleSystems: true });
			return data;
		})
		.catch((error) => {
			console.error(error);
			dispatch({ type: ActionType.FETCH_ERROR });
		});
};

export const updateAssignmentByID = (
	accountID: number, 
	systemID: number,
	accountRole: string,
	updatedAt: { Time: string; Valid: boolean },
	email: string[],
	push: string[],
	sms: string[]
) => (dispatch) => {
	let emailSettings = settingsParser(email, 'email'),
		pushSettings = settingsParser(push, 'push'),
		smsSettings = settingsParser(sms, 'sms');
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/assignment`, {
		method: 'PATCH',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({
			accountID,
			systemID,
			accountRole,
			updatedAt,
			emailSettings,
			pushSettings,
			smsSettings
		}),
	})
		.then((resp) => {
			if (!resp.ok) {
				dispatch({ type: ActionType.NOTIFICATION_SETTINGS_UPDATE_FAILED, systemID });
				throw Error(resp.statusText);
			}
			return resp.json();
		})
		.then((resp) => {
			dispatch({ type: ActionType.NOTIFICATION_SETTINGS_UPDATE, updatedAt: resp.updatedAt, systemID, emailSettings, pushSettings, smsSettings });
			return resp;
		})
		.catch((error) => {
			console.error(error);
			dispatch({ type: ActionType.NOTIFICATION_SETTINGS_UPDATE_FAILED, systemID });
			dispatch({ type: ActionType.FETCH_ERROR });
		});
};

const settingsParser = (settings, type) => {
	const notificationGroups = ['System', 'Heartbeat', 'L1', 'L2', 'L3', 'L4', 'Obstruction'];
	let settingsParsed = {};
	notificationGroups.forEach((notiGroup) => {
		settingsParsed[notiGroup] = false;
	});
	settings.forEach((setting) => {
		settingsParsed[setting] = true;
	});
	return settingsParsed;
};

export const unregisterFromMobileApp = (accountID) => (dispatch) => {
    dispatch({ type: ActionType.UNREGISTER_FROM_MOBILE_APP, unregisterFromMobileAppConfirmed: false });
	let token = localStorage.getItem('w4-token');
	return fetch(`${fetchUrl}/unpair-mobile-app`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`,
		},
		signal: GLOBAL_FETCH_SIGNAL,
		body: JSON.stringify({ accountID }),
	})
		.then((resp) => {
			if (!resp.ok) {
				throw Error(resp.statusText);
			}
			return resp.json();
		})
		.then((data) => {
			dispatch({ type: ActionType.UNREGISTER_FROM_MOBILE_APP, unregisterFromMobileAppConfirmed: true, accountID: accountID });
		})
		.catch((error) => {
			alert('failed');
			dispatch({ type: ActionType.FETCH_ERROR });
		});
};


export const closeNotificationSettingsUpdate = () => (dispatch) => {
	dispatch({ type: ActionType.CLOSE_NOTIFICATION_SETTINGS_UPDATE });
};

export const clearEditAccountState = () => (dispatch) => {
	dispatch({ type: ActionType.CLEAR_EDIT_ACCOUNT_STATE });
};

export const showFilteredSystems = (filteredSystems) => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_ACCOUNT_FILTERED_SYSTEMS,
		payload: filteredSystems,
	});
};

export const showFilteredSystemsNames = (filteredSystems) => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_ACCOUNT_FILTERED_SYSTEMS_NAMES,
		payload: filteredSystems,
	});
};

export const updateFilteredSystemsNames = (isUpdatedName) => (dispatch) => {
	dispatch({
		type: ActionType.UPDATE_ACCOUNT_PICKED_SYSTEM_NAME,
		payload: isUpdatedName,
	});
};

export const showSystemSearchBar = (isVisible: boolean) => (dispatch) => {
	dispatch({
		type: ActionType.SHOW_ACCOUNT_SYSTEM_SEARCH_BAR,
		payload: isVisible,
	});
};

export const getAccount = (askedAccountId) => (dispatch) => {
	let token = localStorage.getItem('w4-token');
	dispatch({
		type: ActionType.CLEAR_ACCOUNT_DATA
	});
	return fetch(`${fetchUrl}/accounts/${askedAccountId}`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
		.then((response) => response.json())
		.then((data) => {
			if (!data) {
				data = null;
			} else {
				if (data.systems.Valid) {
					let ids = data.systems.String.split(',').map((id) => parseInt(id, 10));
					data.systems = ids;
				} else {
					data.systems = [];
				}
			}
			dispatch({
				type: ActionType.GET_ACCOUNT,
				account: data,
			});
		})
		.then(() => {
			dispatch(getVisibleSystemsForAccountShort(askedAccountId));
		})
		.catch((err) => {
			console.error(err);
			dispatch({ type: ActionType.FETCH_ERROR });
		});
};

export const setAskedAccountId = (askedAccountId) => (dispatch) => {
	return dispatch({
		type: ActionType.SET_ASKED_ACCOUNT_ID,
		askedAccountId: askedAccountId,
	});
};
